const removeAnimationClass = (
  ref,
  activeAnimationClass,
  activeStaticClass,
  inactiveAnimationClass,
  inactiveStaticClass,
) => {
  // need to remove "animation" class and add the "non-animation" class so that
  // there is no animation on window resize when it enters a different viewport
  const { current } = ref;
  if (current) {
    const { classList } = current;
    if (classList.contains(activeAnimationClass)) {
      classList.add(activeStaticClass);
      classList.remove(activeAnimationClass);
    } else if (classList.contains(inactiveAnimationClass)) {
      classList.add(inactiveStaticClass);
      classList.remove(inactiveAnimationClass);
    }
  }
};

export default removeAnimationClass;
